import React from 'react';
import { Navigation } from './Navigation';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAuthRoute = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/activate',
  ].includes(location.pathname);
  const isInternalShellRoute =
    location.pathname.startsWith('/dashboard') ||
    location.pathname.startsWith('/personal') ||
    location.pathname.startsWith('/organization') ||
    location.pathname.startsWith('/profile') ||
    location.pathname.startsWith('/users') ||
    location.pathname.startsWith('/college') ||
    location.pathname.startsWith('/company') ||
    location.pathname.startsWith('/admin') ||
    location.pathname === '/help' ||
    location.pathname === '/unauthorized';

  if (isInternalShellRoute) {
    // Dashboard shell manages its own layout (h-screen flex); render with no wrapper interference.
    return <>{children}</>;
  }

  return (
    <div className={`min-h-screen ${isAuthRoute ? 'bg-white' : 'bg-gray-100'}`}>
      <Navigation />
      <main>{children}</main>
    </div>
  );
};
